import { useEffect, useImperativeHandle, useRef, useState } from 'react';
import Spacer from '../../../../components/layout/Spacer';
import { VariableCompensationBoardingCard } from './VariableCompensationBoardingCard';
import { VariableCompensationBridgeCard } from './VariableCompensationBridgeCard';
import {
    FieldWrapper,
} from "@progress/kendo-react-form";
import { PageStates } from '../../../../services/SystemNames';
import { Label } from '../../../../components/layout/Label';
import { Button } from "@progress/kendo-react-buttons";
import Icons  from '../../../../components/layout/icons/Icons';
import DropDownButton from '../../../../components/layout/DropDownButton';
import uuid from 'react-uuid';
import Slide from '../../../../components/layout/Slide';
import { isNumeric, isObjectNull } from '../../../../components/helpers/ObjectHelpers';
import { getElementById, getValidationErrorClassName } from '../../../../components/helpers/ElementHelpers';
import { useHasEditableChanged } from '../hooks/usePilotAssignmentStore';


export const VariableCompensationCard = (
    {
        ref,
        onPilotAssignmentChanged,
        assignmentService
    }) => {

    const hasEditableChanged = useHasEditableChanged();

    const boardingRef = useRef();
    const bridgeRef = useRef();

    useImperativeHandle(ref, () => ({
        onPilotageChanged() {
            boardingRef.current.onPilotageChanged();
            bridgeRef.current.onPilotageChanged();
        },
        onLocationChanged() {
            boardingRef.current.onLocationChanged();
            bridgeRef.current.onLocationChanged();
        },
        onExaminerOnlyChanged() {
            bridgeRef.current.onExaminerOnlyChanged();
        },
        onWastedTripChanged() {
            initialize();
        },
        onValidationChanged(codeStrings) {
            boardingRef.current.onValidationChanged(codeStrings);
            bridgeRef.current.onValidationChanged(codeStrings);
        }
    }));

    const [show, setShow] = useState(false);

    useEffect(() => {
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(!hasEditableChanged) return;
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasEditableChanged]);

    return (
        <Slide show={show}>
            <VariableCompensationBoardingCard
                ref={boardingRef}
                onPilotAssignmentChanged={onPilotAssignmentChanged}
                assignmentService={assignmentService}
            />
            <Spacer height={15} />
            <VariableCompensationBridgeCard
                ref={bridgeRef}
                onPilotAssignmentChanged={onPilotAssignmentChanged}
                assignmentService={assignmentService}
            />
            <Spacer height={30} />
        </Slide>
    )

    function initialize() {
        const pilotAssignment = assignmentService.assignment;
        setShow(!pilotAssignment.isWastedTrip);
    }
}

export const VariableCompensationItem = ({ title, compensation, onEdit, onDelete, isEditable, decimals = 2, hasValidationError = false }) => {

    const dropDownButtonId = uuid();

    return (
        <FieldWrapper>
            <Label hasValidationError={hasValidationError} >
                {title}:
            </Label>
            <div className="k-form-field-wrap border-variable-comp">
                <div className="pilotage-compensation-item-with-actions">
                    <div
                        onClick={onTextClick}
                        className={`${getValidationErrorClassName(hasValidationError)}`}>
                        {getNumber()}
                    </div>
                    <div>
                        {
                            isEditable &&
                                (!isObjectNull(compensation) && isNumeric(compensation.overridenNumber)) ?
                                <DropDownButton
                                    id={dropDownButtonId}
                                    disabled={!isEditable}
                                    items={[
                                        {
                                            name: "Rediger",
                                            action: PageStates.Edit,
                                            source: compensation
                                        }
                                        ,
                                        {
                                            name: "Slett",
                                            action: PageStates.Delete,
                                            source: compensation
                                        }
                                    ]}
                                    icon="chevronDown"
                                    hasValidationError={hasValidationError}
                                    onCallback={onItemClick} />
                                :
                                <Button
                                    disabled={!isEditable}
                                    onClick={() => onEdit(compensation)}
                                    rounded="large"
                                    fillMode="solid"
                                    themeColor={hasValidationError ? "warning" : "base"}>
                                    <Icons iconName="edit" dimensions={24} />
                                </Button>
                        }

                    </div>
                </div>
            </div>
        </FieldWrapper>
    )

    function getNumber() {
        if (isObjectNull(compensation)) return "";
        if (isNumeric(compensation.overridenNumber)) return formatNumber(Number(compensation.overridenNumber));
        if (isNumeric(compensation.calculatedNumber)) return formatNumber(Number(compensation.calculatedNumber));
        return 0;
    }

    function formatNumber(number) {
        if (number === 0) return number;
        return number.toFixed(decimals);
    }

    function onItemClick(e) {
        switch (e.action) {
            case PageStates.Delete:
                onDelete(compensation);
                break;
            default:
                onEdit(compensation);
                break;
        }
    }

    function onTextClick() {
        if (!isEditable) return;

        if (!isObjectNull(compensation) && isNumeric(compensation.overridenNumber)) {
            const button = getElementById(dropDownButtonId);
            if (isObjectNull(button)) return;
            button.click();
        } else {
            onEdit(compensation);
        }
    }
}
